import { Model as o } from "../../../../model.js";
class s extends o {
  constructor(t) {
    super(), this.publicKey = t.publicKey, this.status = t.status, this.readerConfiguration = t.readerConfiguration;
  }
}
export {
  s as StripeEngineConfigModel
};
//# sourceMappingURL=stripeEngineConfig.model.js.map
